/* eslint-disable camelcase */
import React from "react";
import { useSelector } from "react-redux";
import get from "lodash/get";
import { array, object, string } from "prop-types";
import { HorizontalStory } from "./HorizontalStory";
import { MainStory } from "./MainStory";
import { VerticalStory } from "./VerticalStory";
import { useDeviceType } from "../../custom-hooks/useDeviceType";
import CollectionTitle from "../../atoms/CollectionTitle";
import { generateNavigateSlug } from "../../utils";
import { DfpComponent } from "../../ads/dfp-component";
import { getCollectionFromCollections, getStoriesFromCollections } from "../../utils/collection";

import "./three-col-nine-var-two.m.css";

export const ThreeColumnNineStoriesVarTwo = ({ collection, extraProp = "" }) => {
  const {
    row_background_color,
    text_color,
    show_timestamp,
    show_read_time,
    show_row_title,
    show_column_separator,
    show_story_separator,
    show_row_separator,
    enable_sponsor_ad,
    sponsor_ad_details,
    show_row_ad_unit_bottom,
  } = get(collection, ["associated-metadata"], {});
  const collections = getCollectionFromCollections(collection, 3);
  const [firstcollection, secondcollection, thirdcollection] = collections;
  const sectionSlug = extraProp;
  if (
    collections.length <= 0 ||
    (firstcollection?.items.length <= 0 && secondcollection?.items.length <= 0 && thirdcollection?.items.length <= 0)
  ) {
    return null;
  }
  const verticalStory = getStoriesFromCollections(firstcollection, 4);
  const mainStory = getStoriesFromCollections(secondcollection, 1);
  const horizontalStory = getStoriesFromCollections(thirdcollection, 4);
  const sponsorAdConfig = useSelector((state) => get(state, ["qt", "config", "ads-config", "slots", "sponsor_ad"], {}));

  const rowAdBottom = show_row_ad_unit_bottom?.split("/").slice(-1)[0];
  const rowAdBottomDivId = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "ad_div_mapping", rowAdBottom], "")
  );
  const pageType = useSelector((state) => get(state, ["qt", "pageType"], null));
  const device = useDeviceType();
  return (
    <div className="row-component">
      <div
        style={{
          backgroundColor: row_background_color || (enable_sponsor_ad ? "#F7FBFE" : "#FFFFFF"),
          marginBottom: !show_row_separator
            ? "0px"
            : device === "mobile"
            ? "var(--mobile-padding)"
            : "var(--spacing-row-separator)",
        }}
      >
        <div
          styleName="three-col-nine-stories-var-two"
          style={{
            gap: !enable_sponsor_ad ? "0" : "",
            paddingTop: !enable_sponsor_ad || !row_background_color ? "0" : "15px",
          }}
        >
          {show_row_title && (
            <CollectionTitle
              styles="two-col-five-stories"
              collection={collection}
              enableSponsorAd={enable_sponsor_ad}
              sponsorAdDetails={sponsor_ad_details}
              hideTitle={true}
              sectionSlug={sectionSlug}
              sponsorAdConfig={sponsorAdConfig}
            />
          )}

          <div styleName="stories-container">
            <div
              styleName="main-story-container"
              style={{
                borderInline:
                  show_column_separator && device !== "mobile" ? "1px solid var(--row-separator-color)" : "none",
                minWidth: secondcollection?.items.length <= 0 || !secondcollection ? "33%" : "",
                borderTop: show_story_separator || "none",
              }}
            >
              {show_row_title && (
                <CollectionTitle
                  styles="two-col-five-stories"
                  collection={secondcollection}
                  enableSponsorAd={false}
                  sponsorAdDetails={sponsor_ad_details}
                  sponsorAdConfig={sponsorAdConfig}
                  sectionSlug={sectionSlug}
                />
              )}
              {mainStory.map((story, index) => (
                <MainStory
                  key={story.id || index}
                  story={story}
                  showBorder={
                    (device === "mobile" && show_story_separator) || (device !== "mobile" && show_column_separator)
                  }
                  showHeroImage={true}
                  showReadTime={show_read_time}
                  showTimestamp={show_timestamp}
                  sectionSlug={sectionSlug}
                />
              ))}
            </div>
            <div
              styleName="vertical-stories"
              style={{
                minWidth: firstcollection?.items.length <= 0 ? "33%" : "",
              }}
            >
              {show_row_title && (
                <CollectionTitle
                  styles="two-col-five-stories"
                  collection={firstcollection}
                  enableSponsorAd={false}
                  sponsorAdDetails={sponsor_ad_details}
                  sponsorAdConfig={sponsorAdConfig}
                  sectionSlug={sectionSlug}
                />
              )}
              <div styleName="first-column">
                {verticalStory.map((story, index) => (
                  <VerticalStory
                    key={story.id}
                    story={story}
                    showReadTime={show_read_time}
                    showTimestamp={show_timestamp}
                    storySeperator={verticalStory.length > 2 ? show_story_separator : null}
                    columnSeperator={show_column_separator}
                    showThumbnail={true}
                    defaultFallback={true}
                    sectionSlug={sectionSlug}
                  />
                ))}
              </div>
            </div>
            <div
              styleName="horizontal-stories"
              style={{
                border: show_column_separator || "none",
                borderTop: show_story_separator || "none",
                minWidth: thirdcollection?.items.length <= 0 || !thirdcollection ? "33%" : "",
              }}
            >
              {show_row_title && (
                <CollectionTitle
                  styles="two-col-five-stories"
                  collection={thirdcollection}
                  enableSponsorAd={false}
                  sponsorAdDetails={sponsor_ad_details}
                  sponsorAdConfig={sponsorAdConfig}
                  sectionSlug={sectionSlug}
                />
              )}
              <div styleName="third-column">
                {horizontalStory.map((story, index) => (
                  <HorizontalStory
                    key={story.id}
                    story={story}
                    showReadTime={show_read_time}
                    showTimestamp={show_timestamp}
                    storySeperator={show_story_separator}
                    columnSeperator={show_column_separator}
                    textColor={text_color}
                    sectionSlug={sectionSlug}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
        {show_row_separator && <div styleName="row-separator"></div>}
      </div>
      {show_row_ad_unit_bottom && <DfpComponent adStyleName="ad-slot-size-300x250" id={rowAdBottomDivId} />}
    </div>
  );
};

ThreeColumnNineStoriesVarTwo.propTypes = {
  collection: object,
  stories: array,
  extraProp: string,
};

ThreeColumnNineStoriesVarTwo.storyLimit = 3;
